import React from "react";
import { LogoutIcon, MySiteIcon } from "@cashrent/commonground-elements";
import UserAvatar from "../user-avatar/UserAvatar";
import styled from "styled-components";
import { Menu } from "antd";
import { useDispatch } from "react-redux";
import userActionCreators from "action-creators/user";

const renderNavLink = (link, showIcon) => (
  <NavLink
    key={link.path}
    icon={showIcon && link.icon ? <link.icon/> : null}
  >
    {link.label}
  </NavLink>
);


const AuthDialog = ({
  isMobile,
  onNavigate,
  currentUser,
  privateNavItems = [],
  publicNavItems = [],
  userNavItems = [],
}) => {
  const dispatch = useDispatch();
  return (
    <NavMenu
      mode="inline"
      expandIcon={() => null}
      defaultOpenKeys={["dashboard", "profile"]}
      onClick={(event) => {
        onNavigate(event.key);
      }}
    >
      {!isMobile && (
        <NavSubMenu key="dashboard" title="Dashboard" icon={<MySiteIcon />}>
          {privateNavItems.map((item) => renderNavLink(item, false))}
        </NavSubMenu>
      )}
      {currentUser.email && (
        <React.Fragment>
          {isMobile && privateNavItems.map((item) => renderNavLink(item, isMobile))}
          <NavSubMenu
            data-profile
            key="profile"
            title={(
              <UserMedia>
                <UserAvatar currentUser={currentUser} size={30} />
                <UserMediaContent >{currentUser.fullName}</UserMediaContent>
              </UserMedia>
            )}
          >
            {userNavItems.map((item) => renderNavLink(item, false))}
          </NavSubMenu>
        </React.Fragment>
      )}
      {isMobile && publicNavItems.map((item) => {
        if (item.children) {
          return (
            <NavSubMenu key={item.path} title={item.label} icon={item.icon} compact>
              {item.children.map((child) => renderNavLink(child, false))}
            </NavSubMenu>
          );
        }

        return renderNavLink(item, isMobile);
      })}
      {currentUser.email && (
        <NavLink
          icon={<LogoutIcon />}
          onClick={() => {
            dispatch(userActionCreators.logout("/"));
          }}
        >
          Log out
        </NavLink>
      )}
        {!currentUser.email && (
        <React.Fragment>
          <NavLink key="/login">
            Login
          </NavLink>
          <NavLink key="/register">
            Sign up
          </NavLink>
        </React.Fragment>
      )}
    </NavMenu>
  );
};

export default AuthDialog;

 const NavMenu = styled(Menu)`
  border: none;
  width: auto;
  font-weight: 600;

  &.ant-menu-light .ant-menu-item:hover,
  &.ant-menu-light .ant-menu-item-active,
  &.ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  &.ant-menu-light .ant-menu-submenu-active,
  &.ant-menu-light .ant-menu-submenu-title:hover {
    color: var(--primary-color);
  }

  .ant-menu-submenu-selected {
    color: black;
  }
`;

 const NavLink = styled(Menu.Item)`
  .ant-menu-title-content {
    font-size: 13px;
  }

  & > svg {
    margin-right: 10px;
  }

  &.ant-menu-item-selected {
    color: var(--primary-color);
    background-color: white !important;
  }

  &::after {
    border-right: none !important;
  }
`;

const NavSubMenu = styled(Menu.SubMenu)`
  &:not(:first-child) {
    padding-top: ${(p) => (p.compact ? "0px" : "15px")} !important};
  }

  &:not(:last-child) {
    padding-bottom: ${(p) => (p.compact ? "0px" : "15px")} !important};
  }

  .ant-menu-submenu-title > .ant-menu-title-content {
    font-size: ${(p) => (p.compact ? "13px" : "15px")}};
  }

  .ant-menu-submenu-title > svg {
    margin-right: 10px;
  }
  .ant-menu-inline {
    background-color: white;
  }

  &[data-profile="true"] {
    border-top: 1px solid ${(p) => p.theme.color.grey.light[3]};
    border-bottom: 1px solid ${(p) => p.theme.color.grey.light[3]};
  }
`;

const UserMedia = styled.div`
  display: flex;
  align-items: center;
`;

 const UserMediaContent = styled.span`
  display: flex;
  font-weight: ${(p) => p.theme.font.weight.bold};
  font-size: ${(p) => p.theme.font.size[15]};
  margin-left: 10px;
`;

